export const uk = {
    add: 'Добавить',
    'audio-disable-reason': 'Используется из видеофайла',
    cancel: 'Скасувати',
    converting: 'Обработка',
    crop: 'Обрезать',
    edit: 'Изменить',
    'idea-source': 'Вибрати інше зі сторінки',
    'library-source': 'Вибрати з бібліотеки',
    'link-source': 'Завантажити за посиланням',
    'recent-source': 'Вибрати з раніше використаних',
    'smart-center': 'Установить смарт-центр',
    'upload-error': 'При загрузке файла произошла ошибка. Попробуйте позже.',
    'upload-source': "Завантажити з комп'ютера"
};
